export default [
  {
    title: 'Mini Dreamy Room',
    description: 'Spacious and comfortable, this modern furnished room offers a queen-size bed and breathtaking views.',
    photo: 'room_1.png',
    size: 20,
    beds: 1,
    people: 2,
    price: 200
  },
  {
    title: 'Sweet Bungalow',
    description: 'The perfect blend of comfort and culture, our superior room includes a king-size bed with majestic window that demands attention.',
    photo: 'room_2.png',
    size: 50,
    beds: 1,
    people: 2,
    price: 350
  },
  {
    title: 'Los Cocos Suite',
    description: 'If you want a little extra from your stay, you might like our superior rooms. With double doors opening onto a private terrace, you will enjoy spectacular views of our pristine beach.',
    photo: 'room_3.png',
    size: 125,
    beds: 3,
    people: 4,
    price: 450
  }
]
